(function () {
  'use strict';

  var VERSION = '2026-09-04-v3';

  function number(value) {
    var parsed = Number(value);
    return isFinite(parsed) ? parsed : 0;
  }

  function normalize(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function score(review) {
    return Math.max(0, Math.min(5, number(review && review.score)));
  }

  function timestamp(review) {
    var parsed = Date.parse(review && review.created_at ? review.created_at : 0);
    return isNaN(parsed) ? 0 : parsed;
  }

  function reviewCopy(review) {
    return normalize(review && (review.content || review.title));
  }

  function reviewerName(review) {
    return normalize(review && review.user && review.user.display_name) || 'Nest Bedding Customer';
  }

  function displayDate(value) {
    var date = new Date(value || 0);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  function setStars(group, rating) {
    if (!group) return;
    var bounded = Math.max(0, Math.min(5, number(rating)));
    Array.prototype.forEach.call(group.querySelectorAll('[data-review-star]'), function (star, index) {
      var fill = Math.max(0, Math.min(1, bounded - index)) * 100;
      star.style.setProperty('--dynamic-star-fill', fill + '%');
    });
    var ratingLabel = group.parentNode && group.parentNode.querySelector('[data-card-rating]');
    if (ratingLabel) ratingLabel.textContent = 'Rated ' + bounded.toFixed(1) + ' out of 5 stars';
  }

  function payloadData(payload) {
    return payload && payload.response ? payload.response : (payload || {});
  }

  function payloadReviews(data) {
    if (Array.isArray(data.reviews)) return data.reviews;
    if (Array.isArray(data.results)) return data.results;
    return [];
  }

  function isSiteReview(review) {
    var product = review && review.product ? review.product : {};
    var key = normalize(
      (review && (review.domain_key || review.sku || review.product_id)) ||
      product.domain_key ||
      product.id ||
      ''
    );
    return key === 'yotpo_site_reviews';
  }

  function averageRating(data, reviews) {
    var bottomline = data.bottomline || {};
    var average = bottomline.average_score;

    if (average == null && reviews.length) {
      average = reviews.reduce(function (sum, review) {
        return sum + score(review);
      }, 0) / reviews.length;
    }

    return Math.max(0, Math.min(5, number(average)));
  }

  function selectedReviews(reviews, count) {
    return reviews
      .filter(function (review) {
        var verified = review.verified_buyer === true || review.verified_buyer === 'true';
        return verified && score(review) > 0 && reviewCopy(review);
      })
      .sort(function (a, b) {
        return score(b) - score(a) || timestamp(b) - timestamp(a);
      })
      .slice(0, count);
  }

  function updateAggregate(root, rating) {
    var aggregate = root.querySelector('[data-review-aggregate]');
    if (!aggregate || !rating) return;

    var average = aggregate.querySelector('[data-review-average]');
    if (average) average.textContent = rating.toFixed(1);
    setStars(aggregate.querySelector('[data-review-aggregate-stars]'), rating);
    aggregate.classList.add('is-ready');
    aggregate.setAttribute('aria-hidden', 'false');
  }

  function updateCard(card, review) {
    var copy = card.querySelector('[data-review-copy]');
    var author = card.querySelector('[data-review-author]');
    var meta = card.querySelector('[data-review-meta]');
    var verified = review.verified_buyer === true || review.verified_buyer === 'true';
    var date = displayDate(review.created_at);
    var details = [];

    if (copy) {
      copy.textContent = reviewCopy(review);
      copy.setAttribute('title', reviewCopy(review));
    }
    if (author) author.textContent = reviewerName(review);
    if (verified) details.push('Verified Buyer');
    if (date) details.push(date);
    if (meta) meta.textContent = details.join(' · ');

    setStars(card.querySelector('[data-card-stars]'), score(review));
    card.setAttribute('data-review-id', normalize(review.id));
  }

  function init(root) {
    if (!root || root.getAttribute('data-dynamic-testimonials-version') === VERSION) return;
    root.setAttribute('data-dynamic-testimonials-version', VERSION);

    var productEndpoint = root.getAttribute('data-product-review-endpoint');
    var siteRatingEndpoint = root.getAttribute('data-site-rating-endpoint');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-dynamic-review-card]'));
    if (!productEndpoint || !siteRatingEndpoint || !cards.length || !window.fetch) return;

    fetch(productEndpoint, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ per_page: 30 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product reviews request failed');
        return response.json();
      })
      .then(function (payload) {
        var data = payloadData(payload);
        var reviews = payloadReviews(data).filter(function (review) {
          return !isSiteReview(review);
        });
        var selected = selectedReviews(reviews, cards.length);
        if (!selected.length) throw new Error('No eligible product reviews returned');

        cards.forEach(function (card, index) {
          if (selected[index]) {
            updateCard(card, selected[index]);
            card.removeAttribute('hidden');
          } else {
            card.setAttribute('hidden', '');
          }
        });

        root.classList.add('dynamic-testimonials--loaded');
      })
      .catch(function () {
        root.classList.add('dynamic-testimonials--fallback');
      });

    fetch(siteRatingEndpoint, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Site rating request failed');
        return response.json();
      })
      .then(function (payload) {
        var data = payloadData(payload);
        updateAggregate(root, averageRating(data, payloadReviews(data)));
      })
      .catch(function () {
        root.classList.add('dynamic-testimonials--rating-unavailable');
      });
  }

  function initAll(scope) {
    var root = scope && scope.matches && scope.matches('[data-dynamic-testimonials]')
      ? scope
      : null;
    if (root) init(root);

    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-dynamic-testimonials]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
